export const parseBoolean = (v: string | undefined) => (v && ['false', '0'].includes(v.toLocaleLowerCase()) ? false : Boolean(v));
